import React from "react";
import siteConfig from "../config/siteConfig";
import PolicyLayout from "./PolicyLayout";

const sections = [
  { title: "What cookies are", body: ["Cookies are small data files stored by your browser. Similar local-storage technologies may also remember settings on this device."] },
  { title: "Essential storage", body: ["We use essential storage to keep the shopping bag, favourites, security settings and checkout journey working. These functions cannot be switched off through the site."] },
  { title: "Analytics and preferences", body: ["If optional analytics are enabled, they help us understand page performance and general store usage. Preference storage remembers choices such as consent settings."] },
  { title: "Managing cookies", body: ["You can delete or block cookies in your browser. Blocking essential storage may stop the bag or checkout from working correctly."] },
  { title: "Questions", body: [`Questions about our use of cookies can be sent to ${siteConfig.contact.email}.`] },
];

export default function Cookies() {
  return <PolicyLayout eyebrow="Legal" title="Cookie policy" intro={`How ${siteConfig.brandName} uses cookies and local storage.`} sections={sections} />;
}
